<template>
  <div class="basket-toolbar d-flex justify-space-between align-center">
    <div class="basket-toolbar__section pr-2">
      <h2 class="cart-identifier">{{ $t('entities.carts.entity') }}</h2>
      <v-select
        @change="$emit('update:selected-cash-register', $event)"
        :items="cashRegisters"
        :value="selectedCashRegisterId"
        item-text="label"
        item-value="id"
        prepend-icon="mdi-cash-register"
        dense
        hide-details
        class="cash-register-select" />
    </div>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          x-small
          depressed
          fab
          color="error"
          @click="$emit('reset-basket')">
          <v-icon>mdi-restart</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('purchaseV2.basket.resetBasket') }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'BasketToolbar',
  props: {
    areCashRegistersloading: { type: Boolean, default: false },
    cashRegisters: { type: Array, default: () => [] },
    selectedCashRegisterId: { type: String, default: '' },
  },
}
</script>

<style scoped lang="scss">
.basket-toolbar {
  width: 100%;
  margin-bottom: 1rem;

  --cart-identifier-title-color: var(--v-primary-text-darken4);

  .basket-toolbar__section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 65%;
  }
}

.theme--dark .basket-toolbar {
  --cart-identifier-title-color: var(--v-primary-text-base);
}

.cart-identifier {
  font-weight: 600 !important;
  color: var(--cart-identifier-title-color);
}

.cash-register-select {
  max-width: 12.5rem !important;
  margin: 0;
}

.cash-register-select .v-input__control {
  min-height: 2.25rem;
}

.cash-register-select .v-input__slot {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.cash-register-select .v-input__prepend-outer {
  margin-top: 0.4375rem;
}
</style>
